

















































import Vue from "vue";

import IconComment from "@/components/icons/IconComment.vue";
import IconPhone from "@/components/icons/IconPhone.vue";
import IconMail from "@/components/icons/IconMail.vue";

import { Card } from "../Card";

interface IEmployee {
  id: number;
  photo: string;
  name: string;
  position: string;
  description: string;
  phone: string;
  email: string;
}

export default Vue.extend({
  name: "employee",
  components: { Card, IconComment, IconPhone, IconMail },
  props: {
    employee: Object as () => IEmployee,
  },
});
